<template>
  <template v-for="(notification, index) in notifications" :key="index">
    <div class="p-field p-col-6 p-lg-4">
      <AppFormItem label="Email" :error="errors['notificationEmail' + index]">
        <InputText v-model="notification.email" />
      </AppFormItem>
    </div>
    <div class="p-field p-col-2 p-lg-1">
      <InputNumber v-model="notification.timeValue" style="margin-top: 23px" />
    </div>
    <div class="p-field p-col-4 p-lg-2">
      <AppAutoComplete
        v-model="notification.timeUnit"
        :options="timeUnits"
        style="margin-top: 23px"
      ></AppAutoComplete>
    </div>
    <div class="p-field p-col-5 p-sm-4 p-lg-2">
      <AppFormItem label="Antes às">
        <InputNumber
          :min="0"
          :max="23"
          v-model="notification.hour"
          showButtons
          suffix=":00"
        />
      </AppFormItem>
    </div>
    <div class="p-field p-col-2 p-lg-1">
      <Button
        type="button"
        icon="pi pi-times"
        class="p-button-text p-button-secondary"
        style="margin-top: 23px"
        @click="remove(index)"
      ></Button>
    </div>
  </template>
</template>

<script>
const notificationData = () => ({
  email: '',
  timeValue: 1,
  timeUnit: 'day',
  hour: 12,
});

export default {
  name: 'ServiceEditNotification',
  props: {
    errors: Object,
    notifications: Array,
  },
  data() {
    return {
      timeUnits: [
        { id: 'day', name: 'Dia' },
        { id: 'month', name: 'Mês' },
      ],
    };
  },
  created() {
    if (!this.notifications.length) {
      this.add();
    }
  },
  methods: {
    add() {
      const notifications = [...this.notifications, notificationData()];
      this.$emit('update:notifications', notifications);
    },
    remove(index) {
      const notifications = this.notifications.filter((_, i) => index !== i);
      this.$emit('update:notifications', notifications);
    },
  },
};
</script>

<style>
</style>
